<template>
    <v-row>
        <v-dialog @keydown.enter="changePassword()" @keydown.esc="close()" persistent v-model="dialog" height="90%" max-width="350px" max-height="500px">
            <v-card>
                <v-card-title> Alterar senha </v-card-title>

                <v-card-text>
                    <v-form>
                        <v-row class="w-100 flex-col-center">
                            <v-col xs="12" sm="12" md="12" lg="12" class="no-pd-l no-pd-r no-pd-b">
                                <v-text-field
                                    placeholder=" "
                                    label="Senha atual"
                                    color="var(--cor--preta)"
                                    class="no-mg-t"
                                    :type=" ShowCurrentPassword? 'text' : 'password'"
                                    :append-icon="ShowCurrentPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                    @click:append="ShowCurrentPassword = !ShowCurrentPassword"
                                    v-model="currentPassword"
                                    @blur="verifyCurrentPassword()"
                                    autofocus
                                ></v-text-field>
                            </v-col>

                            <v-col xs="12" sm="12" md="12" lg="12" class="no-pd-l no-pd-r no-pd-b">
                                <v-text-field
                                    placeholder=" "
                                    label="Nova senha"
                                    color="var(--cor--preta)"
                                    class="no-mg-t"
                                    :type=" ShowNewPassword? 'text' : 'password'"
                                    :append-icon="ShowNewPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                    @click:append="ShowNewPassword = !ShowNewPassword"
                                    v-model="newPassword"
                                    @change="$v.newPassword.$touch()"
                                    @blur="$v.newPassword.$touch(), verifyValid()"
                                    :error-messages="newPasswordErrors"
                                    :disabled="!currentPasswordCorrect"
                                    :filled="!currentPasswordCorrect"
                                ></v-text-field>
                            </v-col>

                            <v-col xs="12" sm="12" md="12" lg="12" class="no-pd-l no-pd-r no-pd-b">
                                <v-text-field
                                    placeholder=" "
                                    label="Confirmação de senha"
                                    color="var(--cor--preta)"
                                    :type=" ShowConfirmationPassword? 'text' : 'password'"
                                    :append-icon="ShowConfirmationPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                    @click:append="ShowConfirmationPassword = !ShowConfirmationPassword"
                                    class="no-mg-t"
                                    v-model="newPasswordConfirmation"
                                    @change="$v.newPasswordConfirmation.$touch()"
                                    @blur="$v.newPasswordConfirmation.$touch(), verifyValid()"
                                    :error-messages="newPasswordConfirmationErrors"
                                    :disabled="!currentPasswordCorrect"
                                    :filled="!currentPasswordCorrect"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>

                <v-card-actions class="flex-row-end">
                    <v-btn class="text-none" text color="var(--cor--cinzaApp)" @click="close()"> Fechar </v-btn>
                    <v-btn class="text-none" text color="#AC50FF" @click="changePassword()()" :loading="savingProcess" :disabled="!valid"> Salvar </v-btn>
                </v-card-actions>

            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
//Plugins
import { required } from 'vuelidate/lib/validators'

//Funtions
import { passwordConfirmationRule, passwordRule } from "@/support/functions/validation.function";

//Services
import { updatePasswordByCurrentId, isValidPasswordByCurrentId } from "./service/change-password.service";

export default {
    name: '',
    props: {
        dialog: {
            type: Boolean,
            required: true
        }
    },
    computed: {
        newPasswordErrors () {
            const errors = []
            if (!this.$v.newPassword.$dirty) return errors
            !this.$v.newPassword.required && errors.push('Senha é obrigatória.')
            !this.$v.newPassword.passwordRule && errors.push('Senha tem que ter no mínimo 8 caracteres.')
            return errors
        },
        newPasswordConfirmationErrors () {
            const errors = []
            if (!this.$v.newPasswordConfirmation.$dirty) return errors
            !this.$v.newPasswordConfirmation.required && errors.push('Confirmação é obrigatória.')
            !this.$v.newPasswordConfirmation.passwordRule && errors.push('Confirmação tem que ter no mínimo 8 caracteres.')
            !passwordConfirmationRule(this.newPassword, this.newPasswordConfirmation) && errors.push('A confirmação deve ser igual à nova senha!')
            return errors
        }
    },
    validations: {
        newPassword: { required, passwordRule },
        newPasswordConfirmation: { required, passwordRule }
    },
    data: () => ({
        currentPassword: null,
        newPassword: null,
        newPasswordConfirmation: null,
        savingProcess: false,
        ShowCurrentPassword: false,
        ShowNewPassword: false,
        ShowConfirmationPassword: false,
        valid: false,
        currentPasswordCorrect: false
    }),
    methods: {
        verifyValid(){
            if( passwordConfirmationRule( this.newPassword, this.newPasswordConfirmation ) && this.currentPasswordCorrect){
                this.valid = true
            } else {
                this.valid = false
            }
        },
        verifyCurrentPassword(){
            if(this.currentPassword != null && this.currentPassword != ''){
                this.savingProcess = true
                isValidPasswordByCurrentId(this.currentPassword)
                .then(success => {
                    if(success.data.valid ==false){
                        this.$toasted.show('Senha atual incorreta!', { type: 'error' } )
                        this.currentPasswordCorrect = false      
                        this.savingProcess = false 
                    } else {
                        this.currentPasswordCorrect = true   
                        this.savingProcess = false                  
                    }                    
                }) 
                .catch( error => {
                    if (error != null) {
                        this.$toasted.show(error.message, { type: 'error' } )
                        this.savingProcess = false 
                    }
                })           
            } else{
                this.currentPasswordCorrect = false
            }
        },
        changePassword() {
            if( this.valid ) {
                if( passwordConfirmationRule( this.newPassword, this.newPasswordConfirmation ) ) {
                    this.savingProcess = true 

                    const loginObject = {
                        currentPassword: this.currentPassword,
                        newPassword: this.newPassword
                    }
                    updatePasswordByCurrentId( loginObject )
                        .then( () => {
                                this.savingProcess = false
                                this.$toasted.show('Senha alterada com sucesso!', { type: 'success' } )
                                this.close()
                            }
                        )
                        .catch( error => {
                                this.savingProcess = false
                                if (error != null) {
                                    this.$toasted.show(error.message, { type: 'error' } )
                                }
                            }
                        )

                } else {
                    this.$toasted.show('Senha e confirmação precisam ser iguais!', { type: 'info' } )
                }
            }
        },
        close() {
            if( !this.savingProcess ) {
                this.$emit("closeChangePasswordModal", false);
            }
        }
    }
}
</script>